import { isAxiosError } from 'axios';

import { mapApiErrorsToFields } from '@shared/helpers';

import type { TCreateTaskCommentPayload, TTaskCommentFieldErrors } from './types';
import type { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const taskCommentFieldByPointer = {
    text: 'text',
    files: 'files',
} as const satisfies Record<string, keyof TCreateTaskCommentPayload>;

export type TTaskCommentFormError = {
    fieldErrors: TTaskCommentFieldErrors;
    errorMessage: string;
};

export const resolveTaskCommentFormError = (
    error: unknown,
    fallback: string,
    networkFallback: string
): TTaskCommentFormError => {
    if (isAxiosError<IDataResponseError>(error)) {
        const { response } = error;
        if (response && response.status >= 400 && response.status < 500) {
            const errors = response.data?.errors;
            const normalizedErrors = Array.isArray(errors) ? errors.map((fieldError) => {
                const pointer = fieldError?.source?.pointer;
                if (typeof pointer === 'string' && /^files\[\d+\]$/.test(pointer.trim())) {
                    return { ...fieldError, source: { ...fieldError.source, pointer: 'files' } };
                }
                return fieldError;
            }) : [];
            const fieldErrors = mapApiErrorsToFields(normalizedErrors, taskCommentFieldByPointer);
            if (fieldErrors) return { fieldErrors, errorMessage: '' };
        }

        const message = response?.data?.message;
        const defaultMessage = response ? fallback : networkFallback;
        return {
            fieldErrors: {},
            errorMessage: typeof message === 'string' && message.trim()
                ? message.trim()
                : defaultMessage,
        };
    }

    return {
        fieldErrors: {},
        errorMessage: error instanceof Error ? error.message.trim() || fallback : fallback,
    };
};
